<div class="full-view">
  <df-monorepo-dfm-create-location-form></df-monorepo-dfm-create-location-form>
</div>
